import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    Theme,
    teamsLightTheme,
    teamsDarkTheme,
    teamsHighContrastTheme,
    webLightTheme,
    webDarkTheme,
    themeToTokensObject,
    Button,
    DataGrid,
    tokens,
    Menu,
    MenuItem,
    MenuTrigger,
    MenuButton,
    MenuPopover,
    MenuList,
    makeStyles,
    TabList,
    Tab,
    shorthands,
    TableColumnDefinition,
    createTableColumn,
    TableCellLayout,
    DataGridHeader,
    DataGridRow,
    DataGridHeaderCell,
    DataGridBody,
    DataGridCell,
    TableHeaderCell,
    TableRowId,
    DataGridProps,
    OverlayDrawer,
    DrawerHeader,
    DrawerHeaderTitle,
    DrawerBody,
    Drawer,
    Field,
    Input,
    Label,
    DialogContent,
    Dialog,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogActions,
    Title2,
    Checkbox,
    TabValue,
    SelectTabEvent,
    SelectTabData,
    TagGroup,
    Tag,
    useId,
    Text,
    Spinner
} from "@fluentui/react-components";
import { AddRegular, DeleteRegular, Dismiss24Regular, PersonAccountsRegular ,ArrowUploadRegular,  DismissRegular, EditRegular, NavigationRegular, QuestionCircleRegular, RenameRegular, SignOutRegular, CheckmarkRegular, WarningRegular, KeyRegular, EyeOffRegular, EyeRegular } from "@fluentui/react-icons";
import { Dropdown, Option, Toolbar, ToolbarButton } from "@fluentui/react-components";
import useStore from "../../apiFunctions/store/store";
import usePersistentStore from "../../apiFunctions/store/persistentStore";
import { Header, CustomMenuButton } from "documentdrafter-components";
import { ISlimWorkspace, ScreenSize, CustomFluentProvider } from "documentdrafter-components";
import { getCustomTheme } from "documentdrafter-components";
import { getEndpoints, setEndpoints, MainPageSignalRWrapper, ISignalRUpdate, SignalRUpdateType, ISlimCachedDirectory } from "documentdrafter-components";
import "@fluentui/react/dist/css/fabric.min.css";
import React from "react";
import { ICacheUserWithGroups, IUserProps, IUserShare } from "../entitiesAPI";
import { Selection, SelectionMode } from '@fluentui/react/lib/Selection';
import { v4 as uuidv4 } from 'uuid';


import {
    DocumentTableRegular,
    ListRegular

} from "@fluentui/react-icons";
import { IDataSet, IDataSetColumn, PortalGroupSlim, IAutoUpdateSettings } from "../ddentities";
import { _copyAndSort, classNames, classNamesMessageBar, formatDate } from "../basefunctions";
import { getAuthObject } from "../../apiFunctions/authenticateFunctions";
import { AddDataSet, DeleteDataSet, GetAllDataSet, OpenDataSet, ShowSasToken, UpdateAutoUpdateSettingsTable, UpdateDataSet, UpdateDataSetAccess, createSasToken, getShareUsers } from "../../apiFunctions/baseFunctions/baseFunctions";
import { Sticky, StickyPositionType } from '@fluentui/react/lib/Sticky';
import { forEach } from "lodash";
import { LookUpTableGrid } from "./lookUpTableGrid";
import { AccessControl } from "../shared/AccessControl";
import { isLocalOrDevHost } from "../../apiFunctions/baseFunctions/adminFunctions";

var _allUsers: IUserShare[] = [];


export const LookUpTables: React.FC = () => {  

    const userObj: IUserProps = useStore().userObj;
    const isUserAuthenticated = useStore().isUserAuthenticated;
    //SignalR
    const [documentsSignalRUpdateQueue, setDocumentsSignalRUpdateQueue] = useState<ISignalRUpdate[]>([]);
    const screenSize = useStore().screenSize;
    const portalConfig = useStore().portalConfig;
   

    const endPoints = useStore().endpoints;
    const isDark = usePersistentStore().darkMode;
    const theme = isDark ? webDarkTheme : webLightTheme;
    const navigate = useNavigate();
   

    const [dataSets, setDataSets] = React.useState<IDataSet[]>([]);
    const [currentdataSet, SetCurrentDataSet] = React.useState<IDataSet>(null);
    const [hideDialog,setHideDialog] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenDelete, setIsOpenDelete] = React.useState(false);
    const [isOpenRename, setIsOpenRename] = React.useState(false);
    const [isOpenEdit,  setIsOpenEdit] = React.useState(false);
    const [isPopupVisible, setIsPopUpVisible] = React.useState(false);
    const [isUploadVisible, setIsUploadVisible] = React.useState(false);
    const [showMessageBar, setShowMessageBar] = React.useState<boolean>(false);
    const [copyCurrentAutoUpdates, setCopyCurrentAutoUpdates] = React.useState<IAutoUpdateSettings>(null);
    const [NewName, setNewName] = React.useState<string>("");
    const [newEditor, setNewEditor] = React.useState<boolean>(false);
    const containerRef = React.useRef(null);
    const [items, setItems] = React.useState<Item[]>([]);
    const [open, setOpen] = React.useState(false);
    const [dataSetid, setDataSetid] = React.useState<string>("");
    const customTokens = themeToTokensObject(getCustomTheme(!isDark));
    const inputColumnRef = React.useRef<HTMLInputElement>(null);
    const [accessIsOpen, setAccessIsOpen] = React.useState(false);



    type NameCell = {
        label: string;
        id: string;
    };

    type LastUpdatedCell = {
        label: string;
        timestamp: number;

    }
    type LastUpdateBy = {
        label: string;
    }
    type EnabledData = {
        label: string;
        enabled: boolean;
    }

    type Item = {
        name: NameCell;
        lastUpdated: LastUpdatedCell;
        lastUpdateBy: LastUpdateBy;
        enabledDataSet: EnabledData;
    };


    const columns: TableColumnDefinition<Item>[] = [
        createTableColumn<Item>({
            columnId: "name",
            
            compare: (a, b) => {
                return a.name.label.localeCompare(b.name.label);
            },
            renderHeaderCell: () => {
                return "Name";

                
                
            },
            renderCell: (item) => {
                return (
                    <TableCellLayout>
                        <div style={{ width:"500px"} }>{item.name.label}</div>
                        
                    </TableCellLayout>
                );
            },
        }),
        createTableColumn<Item>({
            columnId: "lastUpdated",
            compare: (a, b) => {
                return   a.lastUpdated.timestamp - b.lastUpdated.timestamp;
            },
            renderHeaderCell: () => {
                return "Last updated";
            },

            renderCell: (item) => {
                return (
                <TableCellLayout style={{ width: "200px" }} >
                        {item.lastUpdated.label}
                </TableCellLayout>
                )
            },
        }),
        createTableColumn<Item>({
            columnId: "lastUpdateBy",
            compare: (a, b) => {
                return a.lastUpdateBy.label.localeCompare(b.lastUpdateBy.label);
            },
            renderHeaderCell: () => {
                return "Modified by";
            },
            renderCell: (item) => {
                return (
                    <TableCellLayout >
                        {item.lastUpdateBy.label}
                    </TableCellLayout>
                );
            },
        }),
        createTableColumn<Item>({
            columnId: "enabledDataSet",
            //compare: (a, b) => {
            //    return a.enabledDataSet.enabled. localeCompare(b.enabledDataSet.enabled);
            //},
            renderHeaderCell: () => {
                return "Dataset enabled";
            },
            renderCell: (item) => {
                return (
                    <TableCellLayout >
                        {item.enabledDataSet.enabled?"Yes":"No"}
                    </TableCellLayout>
                );
            },
        }),

    ]

   
    React.useEffect(() => {
        if (isOpen && inputColumnRef.current) {
            inputColumnRef.current.focus();
        }
    }, [isOpen]);

    React.useEffect(() => {
        if (isOpenRename && inputColumnRef.current) {
            inputColumnRef.current.focus();
           /* inputColumnRef.current.select();*/
        }
    }, [isOpenRename]);

    function refreshDataSets(force:boolean) {

        if (isOpenEdit && !force)
            return;

        getAuthObject().then((authResult) => {
            GetAllDataSet(authResult).then((datasets) => {

                var tmpitems: Item[] = [];

                for (var i = 0; i < datasets.length; i++) {

                    var userEmail = "";
                    var formattedDate = "";

                    if (datasets[i].updated != undefined) {
                        let user = _allUsers.find(x => x.id === datasets[i].dataUpdatedBy) 
                        userEmail =  (user === undefined ? "n/a" : user.email);
                    }
                
                    try {
                        formattedDate =  new Date(datasets[i].dataUpdated).toLocaleString('en-GB', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute : '2-digit'

                        });

                    } catch (e) {
                        formattedDate = e.toString();

                    }
                  
                    var tmp: Item = {
                        name: { label: datasets[i].name, id: datasets[i].id },
                        enabledDataSet: { label: datasets[i].enabled ? "Yes" : "No", enabled: datasets[i].enabled },
                        lastUpdateBy: { label: userEmail},
                        lastUpdated: { label: formattedDate, timestamp: new Date(datasets[i].dataUpdated).getTime() }
                    }

                    tmpitems.push(tmp);
                }
                setItems(tmpitems);
                setDataSets(datasets);
            });

        });
    }
    const refreshusers = () => {

        return new Promise(resolve => {

            if (window.MyshareUsers != undefined) {

                var portalusers = window.MyshareUsers;
                var currentUser = JSON.parse(sessionStorage.getItem("user"));

                if (currentUser !== null && currentUser !== undefined) {
                    var u: IUserShare = {
                        email: currentUser.portalUser.Description.email,
                        id: currentUser.portalUser.id,
                        name: currentUser.portalUser.Description.name
                    };
                    portalusers.push(u);
                }
                _allUsers = portalusers;
                resolve("Ok");

            }
            else {

                getAuthObject().then((authResult) => {
                    getShareUsers(authResult).then((usersResult) => {

                        let pl: IUserShare[] = [];
                        pl = usersResult;
                        //_allUsers = pl;
                        window.MyshareUsers = pl;

                        var portalusers = pl;
                        var currentUser = JSON.parse(sessionStorage.getItem("user"));

                        if (currentUser !== null && currentUser !== undefined) {
                            var u: IUserShare = {
                                email: currentUser.portalUser.Description.email,
                                id: currentUser.portalUser.id,
                                name: currentUser.portalUser.Description.name
                            };
                            portalusers.push(u);
                        }
                        _allUsers = portalusers;
                        resolve("Ok");
                    });

                });
            }
        })
    }

    React.useEffect(() => {
        refreshusers().then(() => {
            refreshDataSets(false);    

        });
        
        
      
       
     
      
    }, []);

    interface EmailNotificationsPickerProps {
        currentDataSet: IDataSet;
        onUpdate: (emails: string[]) => void;
    }





    const EmailNotificationsPicker: React.FC<EmailNotificationsPickerProps> = ({
        currentDataSet,
        onUpdate
    }) => {
        const fieldId = useId("email-notifications");
        const [emails, setEmails] = React.useState<string[]>(
            currentDataSet?.autoUpdate?.emailsNotifications || []
        );
        const [inputValue, setInputValue] = React.useState<string>('');
        const [errorMessage, setErrorMessage] = React.useState<string>('');

        // Email validation regex
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // Handle input change
        const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setInputValue(e.target.value);
            setErrorMessage('');
        };

        // Handle adding a new email
        const handleAddEmail = () => {
            if (!inputValue.trim()) {
                return;
            }

            if (!emailRegex.test(inputValue)) {
                setErrorMessage('Please enter a valid email address');
                return;
            }

            // Check for duplicates
            if (emails.includes(inputValue)) {
                setErrorMessage('This email is already in the list');
                return;
            }

            const updatedEmails = [...emails, inputValue];
            setEmails(updatedEmails);
            setInputValue('');
            onUpdate(updatedEmails);
        };

        // Handle removing an email
        const handleTagDismiss = (e: any, data: { value: string }) => {
            const updatedEmails = emails.filter(email => email !== data.value);
            setEmails(updatedEmails);
            onUpdate(updatedEmails);
        };

        // Handle key press (Enter to add email)
        const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleAddEmail();
            }
        };

        return (
            <Field
                validationState={errorMessage ? 'error' : 'none'}
                validationMessage={errorMessage}
            >
                <Label htmlFor={fieldId}>Email Notifications</Label>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                    <Input
                        id={fieldId}
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyPress}
                        placeholder="Enter email address"
                        style={{ flexGrow: 1 }}
                    />
                    <Button
                        appearance="primary"
                        icon={<AddRegular />}
                        onClick={handleAddEmail}
                    >
                        Add
                    </Button>
                </div>

                {emails.length > 0 ? (
                    <TagGroup onDismiss={handleTagDismiss}>
                        {emails.map(email => (
                            <Tag key={email} value={email} dismissible dismissIcon={{ "aria-label": "Remove" }}>
                                {email}
                            </Tag>
                        ))}
                    </TagGroup>
                ) : ("")} 
               
            </Field>
        );
    };

    const DeleteSelectedDataSets = () => {
        return getAuthObject().then((authResult) => {
            var dataSetIdArray = Array.from(selectedRows);
            var deletePromises = dataSetIdArray.map(dataSetId => DeleteDataSet(authResult, dataSetId.toString()));
            return Promise.all(deletePromises);
        });
    }

    //const DeleteSelectedDataSets = () => {
    //    getAuthObject().then(async (authResult) => {
    //        var dataSetIdArray = Array.from(selectedRows);
    //        for (var i = 0; i < dataSetIdArray.length; i++)
    //        {
    //            await DeleteDataSet(authResult, dataSetIdArray[i].toString());
    //        }
    //    });
    //}

    // Check if token exists and is still valid


    const SaveAutoUpdateSettings = async () => {

        const authObj = await getAuthObject();
        const result = await UpdateAutoUpdateSettingsTable(authObj, currentdataSet.id, currentdataSet.autoUpdate);
        setIsUploadVisible(false);

        //find dateset in react state dataSets and update autoUpdate emails and sendOnSucces properties and flush state
        //to reflect changes in the grid use currentdataSet

        let updatedDataSets = dataSets.map(ds => ds.id === currentdataSet.id ? currentdataSet : ds);
        setDataSets(updatedDataSets);
        

   


        

     


    }

    const hasValidToken2 = currentdataSet?.autoUpdate?.expireDate &&
        new Date(currentdataSet.autoUpdate.expireDate) > new Date();


    interface SasTokenManagerProps {
        currentDataSet: IDataSet;
        onUpdate: (updatedDataSet: IDataSet) => void;
    }

    const SasTokenManager: React.FC<SasTokenManagerProps> = ({
        currentDataSet,
        onUpdate
    }) => {
        const fieldId = useId("sas-token");
        const [showToken, setShowToken] = React.useState<boolean>(false);
        const [isLoading, setIsLoading] = React.useState<boolean>(false);
        const [validityMonths, setValidityMonths] = React.useState<number>(12);
        const [tokenValue, setTokenValue] = React.useState<string>("");

        const hasValidToken = currentDataSet?.autoUpdate?.expireDate &&
            new Date(currentDataSet.autoUpdate.expireDate) > new Date();
        // Check if token is expiring soon (within 2 months)
        const isExpiringSoon = hasValidToken &&
            new Date(currentDataSet.autoUpdate.expireDate) < new Date(Date.now() + 2 * 30 * 24 * 60 * 60 * 1000);

        // Format expiry date for display
        const formatExpiryDate = (date: Date | string) => {
            if (!date) return "No expiry date";

            return new Date(date).toLocaleString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
        };

        // Handle creating a new SAS token
        const handleCreateToken = async () => {
            if (!currentDataSet?.id) return;

            setIsLoading(true);
            try {
                const authObj = await getAuthObject();
                const result = await createSasToken(authObj, currentDataSet.id, validityMonths);

                // Update the currentDataSet with the new token and expiry date
                const updatedDataSet = {
                    ...currentDataSet,
                    autoUpdate: {
                        ...currentDataSet.autoUpdate,
                        sasToken: result.token,
                        expireDate: result.expireDate
                    }
                };

                onUpdate(updatedDataSet);
                setShowToken(true); // Show the newly created token
            } catch (error) {
                console.error("Error creating SAS token:", error);
            } finally {
                setIsLoading(false);
            }
        };

        return (
            <div style={{ marginTop: '16px' }}>
                <Field>
                    <Label>SAS Token</Label>

                    {/* Warning for expiring tokens */}
                    {isExpiringSoon && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                            backgroundColor: tokens.colorStatusWarningBackground1,
                            borderRadius: '4px',
                            marginBottom: '8px'
                        }}>
                            <WarningRegular style={{ color: tokens.colorStatusWarningForeground1 }} />
                            <Text size={200} style={{ color: tokens.colorStatusWarningForeground1 }}>
                                This SAS token will expire on {formatExpiryDate(currentDataSet.autoUpdate.expireDate)}.
                                Create a new token before it expires.
                            </Text>
                        </div>
                    )}

                    {/* Display token if exists and still valid */}
                    {hasValidToken ? (
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                <Input
                                    id={fieldId}
                                    type={showToken ? "text" : "password"}
                                    value={showToken? tokenValue: "******************************************" }
                                    readOnly
                                    contentBefore={<KeyRegular />}
                                    contentAfter={
                                        <Button
                                            appearance="transparent"
                                            icon={showToken ? <EyeOffRegular /> : <EyeRegular />}
                                            onClick={async () =>  {
                                                const authObj = await getAuthObject();
                                                const result = await ShowSasToken(authObj, currentDataSet.id);
                                                setTokenValue(result.token);

                                                setShowToken(!showToken)
                                            }
                                            }
                                            aria-label={showToken ? "Hide token" : "Show token"}
                                        />
                                    }
                                    style={{ flexGrow: 1 }}
                                />
                            </div>
                            <Text size={100} style={{ color: tokens.colorNeutralForeground3 }}>
                                Expires on: {formatExpiryDate(currentDataSet.autoUpdate.expireDate)}
                            </Text>
                        </div>
                    ) : (
                        <Text size={200} style={{ marginBottom: '8px' }}>
                            No active SAS token. Create a new one to enable automated updates.
                        </Text>
                    )}

                    {/* Create new token section */}
                    <div style={{
                        marginTop: '16px',
                        padding: '12px',
                        backgroundColor: tokens.colorNeutralBackground3,
                        borderRadius: '4px'
                    }}>
                        <Text weight="semibold">Create New SAS Token</Text>

                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            marginTop: '8px'
                        }}>
                            <Label htmlFor="validity-months">Valid for</Label>
                            <Dropdown
                                id="validity-months"
                                value={validityMonths.toString()}
                                onOptionSelect={(_, data) => setValidityMonths(Number(data.optionValue))}
                                style={{ width: '100px' }}
                            >
                                <Option value="3">3 months</Option>
                                <Option value="6">6 months</Option>
                                <Option value="12">12 months</Option>
                                <Option value="24">24 months</Option>
                            </Dropdown>

                            <Button
                                appearance="primary"
                                onClick={handleCreateToken}
                                disabled={isLoading}
                                icon={isLoading ? <Spinner size="tiny" /> : <KeyRegular />}
                            >
                                {isLoading ? "Creating..." : "Create Token"}
                            </Button>
                        </div>
                    </div>
                </Field>
            </div>
        );
    };

    const AddNewDataSet = (name: string) => {
        getAuthObject().then((authResult) => {
            AddDataSet(authResult, name).then((dataset) => {
                refreshDataSets(false);
                SetCurrentDataSet(dataset);
               
                setIsOpen(false);
                setIsPopUpVisible(true);
                //SetAddColumnOpen(true);
            });


        });
    }
    

    const editDataSet = (dataSet: IDataSet) => {
        getAuthObject().then((authResult) => {
            UpdateDataSet(authResult, dataSet).then((datasetResult) => {

                refreshDataSets(false);
                setIsOpenRename(false);
            });

        });
      

    }
    const OpenSingleDataSet = (datasetid) => {
        getAuthObject().then((authResult) => {
            OpenDataSet(authResult, datasetid).then((dataset) => {
                SetCurrentDataSet(dataset);
            });
        });
    }
  
    function onRenderFooterContent() {
        return (
            <div>
                <Button disabled={NewName.length < 1 || dataSets.findIndex(x => x.name === NewName) > -1} onClick={() => AddNewDataSet(NewName)} style={{ marginRight: "16px" }} >Add</Button>
                <Button onClick={() => { setIsOpen(false); }}>Cancel</Button>
            </div>
        )
    }

    function onRenderFooterContentEdit() {
        return (
            <div>
                <Button onClick={() => {
                    var s = currentdataSet
                    s.name = NewName
                    editDataSet(s)
                }} disabled={NewName.length < 1 || dataSets.findIndex(x => x.name === NewName) > -1} style={{ marginRight: "16px" }}>Save</Button>
                <Button  onClick={() => { setIsOpenEdit(false) }} >Cancel</Button>
            </div>
        )
    }

    const [selectedRows, setSelectedRows] = React.useState(
        new Set<TableRowId>([])
    );
    const onSelectionChange: DataGridProps["onSelectionChange"] = (e, data) => {
        setSelectedRows(data.selectedItems);
    };

    function closeGrid(closeit: boolean) {
        if (closeit)
            setIsOpenEdit(false);
    }

    function forceRefresh() {
        refreshDataSets(true);
    }

   
    function updateAccess(usersToAdd: ICacheUserWithGroups[], usersToRemove: ICacheUserWithGroups[], groupsToAdd: PortalGroupSlim[], groupsToRemove: PortalGroupSlim[]) {

        async function _update() {

            var authObj = await getAuthObject();
            var dataSet = await UpdateDataSetAccess(authObj, currentdataSet.id, usersToAdd.map(user => user.id), usersToRemove.map(user => user.id), groupsToAdd.map(grp=>grp.id) ,groupsToRemove.map(grp=>grp.id))
            let updatedDataSets = dataSets.map(ds => ds.id === dataSet.id ? dataSet : ds);
            setDataSets(updatedDataSets);
            setAccessIsOpen(false);
        }

        _update();

    }

    function checkAutoUpdateEdits():boolean  {
        if (copyCurrentAutoUpdates.sendOnSuccess != currentdataSet.autoUpdate.sendOnSuccess)
            return false;
        //compare copyCurrentAutoUpdates.emailsNotifications with currentdataSet.autoUpdate.emailsNotifications
        if (copyCurrentAutoUpdates.emailsNotifications.length != currentdataSet.autoUpdate.emailsNotifications.length)
            return false;
        for (var i = 0; i < copyCurrentAutoUpdates.emailsNotifications.length; i++) {
            if (copyCurrentAutoUpdates.emailsNotifications[i] != currentdataSet.autoUpdate.emailsNotifications[i])
                return false;
        }   
        return true;
    }

    function closeAccess() {
        setAccessIsOpen(false);
    }


    return (
        <div>
            <div
                style={{
                        marginTop: tokens.spacingVerticalNone,
                        marginBottom: tokens.spacingVerticalXL,
                        marginLeft: "20px",
                        maxWidth: "100%"
                       
                    }}
            >
            <Title2>Lookup tables</Title2>
            </div>
           

            {isOpenEdit && <div>  <LookUpTableGrid closeGrid={closeGrid} dataSet={currentdataSet} refresh={forceRefresh}  ></LookUpTableGrid></div>}


            {!open && 
                
                 <div
                style={{
                   
                    backgroundColor: tokens.colorNeutralBackground1,
                    color: tokens.colorNeutralForeground1,
                    borderTopLeftRadius: tokens.borderRadiusXLarge,
                    borderTopRightRadius: tokens.borderRadiusXLarge,
                    marginLeft: tokens.spacingHorizontalM,
                    marginRight: tokens.spacingHorizontalM,
                                    
                width: "80dvw"


                }}>
                <Toolbar aria-label="Vertical Button" >
                <ToolbarButton icon={<AddRegular></AddRegular>} onClick={() => {
                        setNewName("");
                    setIsOpen(true);

                } }>New
                    
                </ToolbarButton>
                <ToolbarButton icon={<EditRegular></EditRegular>} disabled={selectedRows.size !== 1} onClick={() => {
                   
                    var dataSetIdArray = Array.from(selectedRows);
                    var dataSetId = dataSetIdArray[0];
                    var dataset = dataSets.find(x => x.id === dataSetId.toString());
                    SetCurrentDataSet(dataset);
                    setIsOpenEdit(true);


                }}>Edit
                </ToolbarButton>
                <ToolbarButton icon={<RenameRegular></RenameRegular>} disabled={selectedRows.size !== 1} onClick={() => {
                  
                    var dataSetIdArray = Array.from(selectedRows);
                    var dataSetId = dataSetIdArray[0];
                    var dataset = dataSets.find(x => x.id === dataSetId.toString());
                    SetCurrentDataSet(dataset);
                    setNewName(dataset.name);
                    setIsOpenRename(true);

                } } >Rename
                </ToolbarButton>


                <ToolbarButton icon={<DeleteRegular></DeleteRegular>} disabled={selectedRows.size === 0} onClick={() => {
                    setIsOpenDelete(true);

                } }>
                    Delete
                    </ToolbarButton>

                    {userObj.permissions.findIndex(x => x == "Access management for data manager") > -1 &&
                            <ToolbarButton icon={<PersonAccountsRegular />} disabled={selectedRows.size !== 1} onClick={() => {

                            var dataSetIdArray = Array.from(selectedRows);
                            var dataSetId = dataSetIdArray[0];
                            var dataset = dataSets.find(x => x.id === dataSetId.toString());
                            SetCurrentDataSet(dataset);
                            setAccessIsOpen(true);

                        }}>
                            Access
                        </ToolbarButton>}



                

                 {userObj.permissions.findIndex(x => x == "Access management for data manager") > -1 && isLocalOrDevHost() &&
                <ToolbarButton icon={<ArrowUploadRegular />} disabled={selectedRows.size !== 1} onClick={() => {

                    var dataSetIdArray = Array.from(selectedRows);
                    var dataSetId = dataSetIdArray[0];
                    var dataset = dataSets.find(x => x.id === dataSetId.toString());
                    SetCurrentDataSet(dataset);
                                setCopyCurrentAutoUpdates(dataset.autoUpdate);
                    setIsUploadVisible(true);

                }}>
                    Batch update
                </ToolbarButton>}



        </Toolbar></div >}

            {isUploadVisible && <>
                <OverlayDrawer
                    size= "medium"
                    position="end"
                    open={isUploadVisible}
                    onOpenChange={(_, state) => setIsUploadVisible(state.open)}
                >
                    <DrawerHeader>
                        <DrawerHeaderTitle
                            action={
                                <Button
                                    appearance="subtle"
                                    aria-label="Close"
                                    icon={<Dismiss24Regular />}
                                    onClick={() => setIsUploadVisible(false)}
                                />
                            }
                        >
                        Lookup table - batch update
                        </DrawerHeaderTitle>
                    </DrawerHeader>

                    <DrawerBody>
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ paddingTop: '10px' }}>
                                <Text weight="semibold">Using batch update</Text>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingTop: '10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Text>
                                            To use batch updates, you need a SAS token url for a Blob storage and use that to upload files for processing.
                                        </Text>
                                    </div>
                                </div>
                            </div>
                           

                            {/* Add the SAS Token manager */}
                            {currentdataSet && (
                                <SasTokenManager
                                    currentDataSet={currentdataSet}
                                    onUpdate={(updatedDataSet) => {
                                        SetCurrentDataSet(updatedDataSet);
                                    }}
                                />
                            )}
                            <div style={{ paddingTop :'10px'}}>
                            {currentdataSet && hasValidToken2 && <>
                                <EmailNotificationsPicker
                                    currentDataSet={currentdataSet}
                                    onUpdate={(emails) => {
                                        // Update your dataset with the new emails
                                        const updatedDataSet = {
                                            ...currentdataSet,
                                            autoUpdate: {
                                                ...currentdataSet.autoUpdate,
                                                emailsNotifications: emails
                                            }
                                        };
                                        SetCurrentDataSet(updatedDataSet);
                                        // If you want to save immediately, call your editDataSet function
                                        // editDataSet(updatedDataSet);
                                    }}
                                />
                                  <Checkbox
                                checked={currentdataSet?.autoUpdate?.sendOnSuccess}
                                onChange={(ev, data) => {
                                    const updatedDataSet = {
                                        ...currentdataSet,
                                        autoUpdate: {
                                            ...currentdataSet.autoUpdate,
                                            sendOnSuccess: data.checked as boolean
                                        }
                                    };
                                    SetCurrentDataSet(updatedDataSet);
                                }}
                                label="Send emails on successful updates"
                            />
                            </>

                                }

                                <div style={{ paddingTop: '10px' }}>
                                    <Text weight="semibold">Update information</Text>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingTop: '10px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Text>If your table will not have more than 10,000 rows, you can send a single file and update the entire table in one go.<br/>
                                                If you will end up with more than 10,000 rows, you need configure a column in the table to be the “Foreign key”. Right-click on the column name to do this. Following that, you need to pre-pend the name of the update file with:
                                                <br/>
                                                -	“add_” <br/>
                                                -	“update_”<br/>
                                                -	“delete_”<br />
                                            </Text>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ paddingTop: '10px' }}>
                                    <Text weight="semibold">File information</Text>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingTop: '10px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Text>
                                                You send either a csv or excel sheet which has the same structure as the lookup table you are updating. You can verify this by exporting the lookup table to Excel.<br/>
                                                If you send a csv file it needs to delimitered with semicolon and all strings encapsulated with quotation marks.
                                            </Text>
                                        </div>
                                    </div>
                                </div>
                            </div>

                          

                        

                        {/* Footer with buttons */}
                        {(1===1) && <div style={{ display: 'flex', justifyContent: 'flex-start', padding: '10px', position: "fixed", bottom: "0", left: "0", width: "95%" }}>
                                <Button icon={<><CheckmarkRegular /></>} onClick={() => SaveAutoUpdateSettings()} disabled={checkAutoUpdateEdits() } appearance="primary">Save</Button>
                            <Button icon={<DismissRegular></DismissRegular>} onClick={() => setIsUploadVisible(false)} style={{ marginLeft: '10px' }}>Cancel</Button>
                            </div>}
                        </div>
                    </DrawerBody>
                    

                </OverlayDrawer>

            </>}



                {!open &&
 <div
                style={{
                    overflowX: "hidden",

                    backgroundColor: tokens.colorNeutralBackground1,
                    color: tokens.colorNeutralForeground1,
                    
                    marginLeft: tokens.spacingHorizontalM,
                    marginRight: tokens.spacingHorizontalM,

                height: "69dvh",
                width: "80dvw"


                }}>


                    <DataGrid
                items={items}
                columns={columns}
                sortable
                selectionMode="multiselect"

                getRowId={(item) => item.name.id}
                focusMode="composite"
                size="medium"
                selectedItems={selectedRows}
                onSelectionChange={onSelectionChange}
                style={{ overflow: "auto" } }

            >
                <DataGridHeader>
                    <DataGridRow
                        selectionCell={{
                            checkboxIndicator: { "aria-label": "Select all rows" },
                        }}
                    >
                        {({ renderHeaderCell }) => (
                            <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                        )}

                      


                    </DataGridRow>
                   
                </DataGridHeader>
                <DataGridBody<Item>>
                    {({ item, rowId }) => (
                        <DataGridRow<Item>
                            key={rowId}
                            selectionCell={{
                                checkboxIndicator: { "aria-label": "Select row" },
                            }}
                        >
                            {({ renderCell }) => (
                                <DataGridCell>{renderCell(item)}</DataGridCell>
                            )}
                        </DataGridRow>
                    )}
                </DataGridBody>
            </DataGrid></div>
            }




            


            <Dialog open={isOpen}>
                <DialogSurface  >
                    <DialogBody>
                        <DialogTitle
                            action={
                                <Button
                                    appearance="subtle"
                                    aria-label="Close"
                                    icon={<DismissRegular />}
                                    onClick={() => {
                                        setIsOpen(false);
                                    }}
                                />
                            }
                        >
                            Add new dataset
                        </DialogTitle>
                        <DialogContent>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Label >
                                    Name
                                </Label>
                                    <Input autoFocus={isOpen} defaultValue={NewName} onChange={(e, v) => { setNewName(e.currentTarget.value); }} ref={inputColumnRef} />
                            </div>

                        </DialogContent>
                            <DialogActions>
                                <Button onClick={() => {
                                    setIsOpen(false);

                                }} >Close</Button>

                             
                            <Button appearance="primary" disabled={NewName.length===0 }
                                onClick={() => {
                                    AddNewDataSet(NewName);
                                    setNewName("");
                                    setIsOpen(false);
                                }}
                            >
                                Ok
                            </Button>
                        </DialogActions>


                    </DialogBody>
                </DialogSurface>
            </Dialog>
            <Dialog open={isOpenRename}>
                <DialogSurface  >
                    <DialogBody>
                        <DialogTitle
                            action={
                                <Button
                                    appearance="subtle"
                                    aria-label="Close"
                                    icon={<DismissRegular />}
                                    onClick={() => {
                                        setIsOpenRename(false);
                                    }}
                                />
                            }
                        >
                            Rename dataset
                        </DialogTitle>
                        <DialogContent>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Label >
                                    Name
                                </Label>
                                    <Input defaultValue={NewName} autoFocus={isOpenRename} onChange={(e, v) => { setNewName(e.currentTarget.value); }} ref={inputColumnRef} />
                            </div>

                        </DialogContent>
                            <DialogActions>
                                <Button onClick={() => {
                                    setIsOpenRename(false);

                                }} >Close</Button>



                            <Button appearance="primary" disabled={NewName.length === 0}
                                onClick={() => {
                                    currentdataSet.name = NewName;
                                    editDataSet(currentdataSet);
                                    
                                }}
                            >
                                Ok
                            </Button>
                        </DialogActions>


                    </DialogBody>
                </DialogSurface>
            </Dialog>
            <Dialog open={isOpenDelete}>
                <DialogSurface  >
                    <DialogBody>
                        <DialogTitle
                            action={
                                <Button
                                    appearance="subtle"
                                    aria-label="Close"
                                    icon={<DismissRegular />}
                                    onClick={() => {
                                        setIsOpenDelete(false);
                                    }}
                                />
                            }
                        >
                            Delete?
                        </DialogTitle>
                        <DialogContent>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                               
                                Please confirm to delete {selectedRows.size} {selectedRows.size === 1 ? "dataset" : "datasets"}, when deleted the datasets can not be restored.
                            </div>

                        </DialogContent>
                            <DialogActions>

                               
                                    <Button onClick={() => {
                                        setIsOpenDelete(false);

                                    }} >Close</Button>
                                <Button 
                                    appearance="primary"
                                onClick={() => {
                                    DeleteSelectedDataSets().then(() => {
                                    refreshDataSets(false);
                                        setIsOpenDelete(false);
                                        setSelectedRows(new Set<TableRowId>([]));

                                    })
                                    
                                }}
                            >
                                Delete {selectedRows.size} {selectedRows.size===1?"dataset": "datasets"}
                            </Button>
                        </DialogActions>


                    </DialogBody>
                </DialogSurface>
            </Dialog>
                {accessIsOpen && <AccessControl close={closeAccess} users={currentdataSet.usersWithAccess} groups={currentdataSet.groupsWithAccess} update={updateAccess}  ></AccessControl>}
           






         
            <div
                style={{
                    height: "33px",
                    width: "80dvw",
                    backgroundColor: tokens.colorNeutralBackground1,
                    borderBottomRightRadius: tokens.borderRadiusXLarge,
                    borderBottomLeftRadius: tokens.borderRadiusXLarge,
                    marginLeft: tokens.spacingHorizontalM,
                }}
            />
            </div>
      
      


        //<div style={{ backgroundColor: "#ffffff", width: "100vw", height: "100vh" }} ref={containerRef}>

        //    <div style={showMessageBar ? {} : { display: "hidden" }} className={classNamesMessageBar.MessageBarContainer}>
        //        {showMessageBar &&
        //            <MessageBar isMultiline={false} messageBarType={MessageBarType.success} dismissButtonAriaLabel="Close" onDismiss={() => { removeMsgBar() }}  >Record is created
        //            </MessageBar>
        //        }
        //    </div>


        //<ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto} styles={{ root: { marginTop: "50px", marginLeft: "244px" } }}>
        //    {!isPopupVisible && <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
        //        <div>
        //            <CommandBar

        //                items={commandItems}
        //                ariaLabel="Use left and right arrow keys to navigate between commands"
        //            />

        //        </div>
        //    </Sticky>}

        //    <div className={[classNames.columnPadding, classNames.defaultBackGround].join(' ')}>
        //        <div style={{ width: "1100px" }} >
        //            <MarqueeSelection selection={_selectCon}>
        //                <DetailsList
        //                    items={dataSets}
        //                    compact={false}

        //                    columns={_columns}
        //                    selectionMode={SelectionMode.single}
        //                    setKey="key"
        //                    selection={_selectCon}
        //                    selectionPreservedOnEmptyClick={true}
        //                    enterModalSelectionOnTouch={true}
        //                    ariaLabelForSelectionColumn="Toggle selection"
        //                    ariaLabelForSelectAllCheckbox="Toggle selection for all items"
        //                    checkButtonAriaLabel="Row checkbox"

        //                />
        //            </MarqueeSelection>
        //        </div>
        //    </div>
        //    <div style={{ padding: '5px', width: '200px' }}>
        //    </div>
        //</ScrollablePane>
        //</div>
    )


}


